module.exports = __webpack_public_path__ + "static/Holsum-60-anos-997857093f3ba8d7c912726cc3215ba5.png";